import { useShallow } from 'zustand/react/shallow';
import { useMediaQuery } from '@mui/material';

import { useRoomStore } from '@src/stores';
import { useTheme } from '@src/contexts';

const useInfoModal = () => {
  const { theme } = useTheme();
  const isMobile = useMediaQuery('(max-width: 768px)');

  const { isInfoModalOpen, setIsInfoModalOpen, infoModalContent, setCheckboxState, setInfoModalContent } = useRoomStore(
    useShallow((state) => ({
      isInfoModalOpen: state.isInfoModalOpen,
      setIsInfoModalOpen: state.setIsInfoModalOpen,
      infoModalContent: state.infoModalContent,
      setCheckboxState: state.setCheckboxState,
      setInfoModalContent: state.setInfoModalContent,
    }))
  );

  const { size, title, buttons, description, footer, icon, checkbox } = infoModalContent || {};

  const resetModalState = () => {
    setIsInfoModalOpen(false);
    setInfoModalContent(null);
    if (checkbox !== undefined) {
      setCheckboxState(false);
    }
  };

  const handleModalButtonClick = (buttonAction?: () => void) => {
    if (buttonAction) buttonAction();
    resetModalState();
  };

  const handleOnCloseModal = () => {
    infoModalContent?.handleOnCloseModal?.();
    resetModalState();
  };

  return {
    size,
    icon,
    title,
    footer,
    buttons,
    description,
    checkbox,
    theme,
    isMobile,

    isInfoModalOpen,
    setIsInfoModalOpen,
    infoModalContent,
    handleModalButtonClick,
    handleOnCloseModal,
  };
};

export default useInfoModal;
